import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
} from "@mui/material";
import { getStyles } from "./Header.styles";

const Header: React.FC = () => {
  const styles = getStyles();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <AppBar position="static" sx={styles.appBar}>
      <Toolbar sx={styles.toolbar}>
        <Box
          sx={styles.logo}
          onClick={() => window.open("https://tinyurl.com/58t98krr", "_blank")}
        >
          <img src="/assets/images/logo.svg" alt="Bookster Logo" />
        </Box>

        <Box sx={styles.navLinks}>
          <Button
            variant="contained"
            onClick={() => {
              window.open("http://tinyurl.com/58t98krr", "_blank");
            }}
          >
            Ce este Bookster?
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              const donationSection = document.getElementById(
                "results-section"
              );
              donationSection?.scrollIntoView({
                behavior: "smooth",
              });
            }}
          >
            Rezultate
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              window.open("https://tinyurl.com/3v7u38ab", "_blank");
            }}
          >
            Intră în cont
          </Button>
        </Box>

        <IconButton onClick={handleMenuOpen} sx={styles.menuButton}>
          <img src="/assets/images/menu.svg" alt="menu" />
        </IconButton>

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          sx={styles.menuStyles}
        >
          <MenuItem
            sx={styles.menuItemStyles}
            onClick={() => {
              handleMenuClose();
              window.open("http://tinyurl.com/58t98krr", "_blank");
            }}
          >
            Ce este Bookster?
          </MenuItem>
          <MenuItem
            sx={styles.menuItemStyles}
            onClick={() => {
              handleMenuClose();
              const donationSection = document.getElementById(
                "results-section"
              );
              donationSection?.scrollIntoView({
                behavior: "smooth",
              });
            }}
          >
            Rezultate
          </MenuItem>
          <MenuItem
            sx={styles.menuItemStyles}
            onClick={() => {
              handleMenuClose();
              window.open("https://tinyurl.com/3v7u38ab", "_blank");
            }}
          >
            Intră în cont
          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
